import { createSelector } from '@reduxjs/toolkit'

import type { ReduxState } from 'src/store/types'

const getKycRoot = (state: ReduxState) => state.kyc

export const getKycStatusSelector = createSelector(getKycRoot, (kyc) => kyc.status)

export const getKycIsLoadingSelector = createSelector(getKycRoot, (kyc) => kyc.isLoading)

export const isKYCRequiredSelector = createSelector(getKycStatusSelector, (status) => {
  return ['initial', 'in_review', 'declined', 'doc_declined', 'id_confirmed'].includes(status)
})

export const KYCinReviewSelector = createSelector(getKycStatusSelector, (status) => {
  return status === 'doc_review'
})

export const isKYCConfirmedSelector = createSelector(getKycStatusSelector, (status) => {
  return status === 'confirmed'
})

export const jumioKycAddressSelector = createSelector(getKycRoot, (kyc) => kyc?.info)

export const jumioKycStateSelector = createSelector(jumioKycAddressSelector, (address) => address?.state?.toUpperCase())
